import { useTranslation } from 'react-i18next';

interface ServiceItem {
  icon: string;
  title: string;
  description: string;
  features: string[];
}

export default function ServicesOverview() {
  const { t } = useTranslation();
  const services = t('servicesOverview.items', { returnObjects: true }) as ServiceItem[];

  return (
    <section id="services" className="w-full py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-50 text-primary-700 text-xs font-semibold mb-4">
            <i className="ri-sparkling-line"></i>
            {t('servicesOverview.badge')}
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            {t('servicesOverview.title')}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            {t('servicesOverview.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className="group p-6 md:p-7 rounded-xl bg-background-100 border border-background-200/70 transition-all hover:border-primary-200 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${service.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{service.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{service.description}</p>
              <ul className="flex flex-col gap-1.5">
                {service.features.map((feat) => (
                  <li key={feat} className="flex items-center gap-2 text-xs text-foreground-500">
                    <div className="w-1 h-1 rounded-full bg-primary-400 flex-shrink-0"></div>
                    {feat}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}